import React from 'react'

const site = JSON.parse(localStorage.getItem('site'))
const acc = JSON.parse(localStorage.getItem('acc'))

import { ReactComponent as OperationJuice } from '../assets/svg/Header/OperationJuice.svg'

export const suppliers = [
  {
    permission: site?.avalible?.operations?.juise,
    link: '/admin/juice',
    name: `Production ${localStorage.getItem('name') === 'TPO' ? 'Juice' : 'CCN'}`,
    icon: <OperationJuice width={'30px'} height={'30px'}/>,
    enabled: true,
    disabled: false,
  },
]
